// @ts-check

/** @file Owner-partitioned durable project catalog keys without transport dependencies. */

/**
 * Builds the owner-partitioned catalog cursor key.
 * @param {string} userId Canonical authenticated user UUID.
 * @returns {string} Owner-partitioned cursor key.
 */
export function projectCatalogCursorKey(userId) {
  return `project-sync-catalog-v2:${userId}`
}
